import z from 'zod';
import { PRODUCT_TYPE_SCHEMA } from '../product-type/product-types.ts';
import {
    TEMPLATE_GROUP_DESCRIPTION_SCHEMA,
    TEMPLATE_GROUP_TITLE_SCHEMA,
    TEMPLATE_TYPE_SCHEMA,
} from './template-type.ts';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category.ts';
import { FREIGHT_TYPE_SCHEMA } from '../product-channel/freight-type.ts';
import { DISPOSAL_PURPOSE_SCHEMA } from '../product-channel/disposal-purpose.ts';

export const PreFillDataSchema = z.object({
    unit: SUPPORTED_UNITS_SCHEMA.optional().nullable(),
});

export const ProductCharacteristicSchema = z.object({
    freightType: FREIGHT_TYPE_SCHEMA.optional(),
    disposalPurpose: DISPOSAL_PURPOSE_SCHEMA.optional(),
});

export const TemplateProductSchema = z.object({
    id: z.string().uuid(),
    type: PRODUCT_TYPE_SCHEMA,
    category: PRODUCT_CATEGORY_SCHEMA,
    //TODO this is effectively "any" now, but fixing it breaks other parts of the code
    prefilledData: z.any().parse(PreFillDataSchema.optional().nullable()),
    templateId: z.string().optional().nullable(),
    productCharacteristics: ProductCharacteristicSchema.optional(),
});

export const TemplateCategorySchema = z.enum(['ORDER', 'POSITION']);

export const GetTemplateUrlSchema = z.object({
    templateId: z.string().uuid(),
});

export const TemplateSchema = z.object({
    id: z.string().uuid(),
    templateGroupId: z.string().uuid(),
    name: TEMPLATE_GROUP_TITLE_SCHEMA,
    type: TEMPLATE_TYPE_SCHEMA,
    description: TEMPLATE_GROUP_DESCRIPTION_SCHEMA.optional().nullable(),
    preSelectedProducts: z.array(TemplateProductSchema),
    allowedProducts: z.array(TemplateProductSchema),
    templateCategories: z.array(TemplateCategorySchema),
});

export const GetTemplateResponseSchema = TemplateSchema;

export type Template = z.infer<typeof TemplateSchema>;
export type TemplateProduct = z.infer<typeof TemplateProductSchema>;
export type TemplateCategory = z.infer<typeof TemplateCategorySchema>;
export type GetTemplateResponse = z.infer<typeof GetTemplateResponseSchema>;
export type ProductCharacteristic = z.infer<typeof ProductCharacteristicSchema>;

export const TEMPLATE_CATEGORIES = {
    ORDER: TemplateCategorySchema.enum.ORDER,
    POSITION: TemplateCategorySchema.enum.POSITION,
} as const;

export const TRANSPORT_PRODUCT_CHARACTERISTICS_SCHEMA = PRODUCT_TYPE_SCHEMA.extract(['CUSTOM_TRANSPORT']);

export const MATERIAL_PRODUCT_CHARACTERISTICS_SCHEMA = PRODUCT_TYPE_SCHEMA.extract([
    'CUSTOM_BULK_MATERIAL',
    'CUSTOM_RECYCLED_BULK_MATERIAL',
    'CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING',
    'CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL',
    'CUSTOM_HAZARDOUS_WASTE_RECYCLING',
    'CUSTOM_HAZARDOUS_WASTE_DISPOSAL',
    'CUSTOM_CONCRETE',
    'CUSTOM_ASPHALT',
]);
